import { useQuery } from '@tanstack/react-query';

import { getCarouselMetrics } from '~/services/ExperiencesService';

import { experiencesQueryKeys } from './experiencesQueryKeys';

export function useGetCarouselMetrics() {
  return useQuery({
    queryKey: experiencesQueryKeys.carouselMetricsList(),
    queryFn: () => getCarouselMetrics(),
  });
}
